import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getArea,
  getParticularPage,
  getNext,
  getPrevious,
  createArea,
  updateArea,
  handleSearch,
  getAreaById,
} from "./thunk";

const initialState = {
  areas: [],
  edit: false,
  area: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingArea: false,
  loadingNext: false,
  showCreateModal: false,
};

export const areaSlice = createSlice({
  name: "area",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllArea: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingArea = false;
      state.area = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createArea.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createArea.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createArea.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getAreaById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAreaById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.area = action.payload.data;
    });
    builder.addCase(getAreaById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.area = null;
    });
    builder.addCase(updateArea.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateArea.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateArea.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getArea.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingArea = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getArea.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingArea = false;
        state.areas = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getArea.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingArea = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllArea } = areaSlice.actions;

export default areaSlice.reducer;
